import React from 'react';
import { Card, CardBody, CardTitle, Col, Container, Row } from 'reactstrap';
import Breadcrumb from 'Components/Common/Breadcrumb';
// import Filter from './Filter';
// import Detail from './Detail';

const ConsentMain = () => {
  document.title = "Зөвшөөрөл";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Зөвшөөрөл" breadcrumbItem="Зөвшөөрөл" />
          <Row>
            {/* <Filter />
            <Detail /> */}
          </Row>
        </Container>
      </div>
    </React.Fragment >
  );
}

export default ConsentMain;